import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=727d1477&scoped=true"
import script from "./offline.vue?vue&type=script&lang=ts"
export * from "./offline.vue?vue&type=script&lang=ts"
import style0 from "./offline.vue?vue&type=style&index=0&id=727d1477&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727d1477",
  null
  
)

export default component.exports